import { HttpClient } from '@angular/common/http';
import { Component,  Input, OnInit } from '@angular/core'; 
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
// import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-range-price-admin-config',
  templateUrl: './range-price-admin-config.component.html',
  styleUrls: ['./range-price-admin-config.component.scss']
})
export class AtwRangePriceAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() device: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  fonts = [];
  // xử lý chỉ mở được 1 menu 1 lần
  public openMap: any = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };
  isViewAll: boolean = false;
  currentViewAll: any = {};
  stylefields = [
    {
      title: 'dieu_chinh_vien',
      index: 1,
    },
    {
      title: 'dieu_chinh_noi_dung',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4
    },
    {
      title: 'dieu_chinh_vien_o_nhap',
      index: 5,
    },
  ];
  // Mảng kiểu hiển thị của khoảng giá
  displayType = [
    {
      title: 'mau_01', //mẫu có nút tìm kiếm và có tiêu đề
      value: 1,
    },
    {
      title: 'mau_02', //mẫu có nút tìm kiếm và không tiêu đề
      value: 2,
    },
    {
      title: 'mau_03', //mẫu không có nút tìm kiếm và có tiêu đề
      value: 3,
    },
    {
      title: 'mau_04', //mẫu không có nút tìm kiếm và không tiêu đề
      value: 4,
    },
  ]
  configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;
  
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb, 
    private http: HttpClient,
    public functionService: FunctionService,
    public vhEventMediator: VhEventMediator, 
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
    forkJoin([
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([fonts]: any) => {
      this.fonts = fonts;
    })
  }

  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }

  /**
  * @param index : vị trí phần tử muốn xóa
  * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó. 
  */
  // deleteGradient(index) {
  //   const data = (this.device == 'desktop') ? this.objectChoosing.desktop_gradient_button : this.objectChoosing.mobile_gradient_button;
  //   data[`arr_gradient_${this.device}`].splice(index,1);
  //   this.updateCss( this.device + '_gradient_button', data);
  // }
  // Xem thêm
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  // updateConfig() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_config']: this.config,
  //       // data: this.data
  //     })
  //     .then((bool: any) => {
  //     });
  // }

  // updateClass() {
  //   this.vhQueryAutoWeb
  //     .updateObject(this.objectChoosing._id, {
  //       [this.device + '_class']: this.class,
  //     })
  //     .then((bool: any) => {
  //     });
  // }
  // // */ Hàm update object vào database.
  // // */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
  //     })
  // }

  // // */
  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
  //     .then((bool: any) => {
  //     })
  // }

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }

}
